import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=f4203e40&scoped=true&"
import script from "./Edit.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Edit.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4203e40",
  null
  
)

export default component.exports